export const BANKSLIP_PAYMENT_PT_BR = {
	// Barcode input step
	infoTitle: "Informação",
	barcodeInfo:
		"Solicitações realizadas até 15h (horário de Brasília) são processados no mesmo dia útil. Após esse horário, o pagamento é feito no próximo dia útil e pode ter cobrança de juros ou multa pelo emissor.",
	barcodeLabel: "Código de barras",
	barcodePlaceholder: "Digite ou cole o código do boleto aqui",
	invalidBarcode: "Código de barras inválido. Verifique e tente novamente.",
	pasteCode: "Colar código",
	stepBarcode: "Código de barras",
	stepValue: "Valor do boleto",
	stepReview: "Revisão dos dados",

	// Payment amount section (Step 1)
	paymentAmountQuestion: "Quanto você quer pagar?",
	suggestedAmountMessage: "O valor sugerido para este boleto é de {{amount}}",
	paymentAmountLabel: "Valor de pagamento",

	// Review step tabs
	tabValues: "Valor do boleto",
	tabInfo: "Revisão dos dados",

	// Review step - Values
	valuesReview: "Revisão dos Valores",
	bankSlipValue: "Valor do boleto",
	anticipationFee: "Multa e juros",
	discounts: "Descontos",
	totalToPay: "Valor total a pagar",

	// Review step - Info
	bankSlipInfo: "Informações do Boleto",
	beneficiary: "Beneficiário",
	recipientTaxId: "CNPJ/CPF do beneficiário",
	barCode: "Número do código",
	dueDate: "Vencimento",
	bank: "Banco",

	// Alerts
	inactiveBankslipTitle: "Boleto inativo",
	inactiveBankslipMessage:
		"Este boleto já foi pago ou ocorreu algum problema na emissão. Verifique o código e tente novamente.",
	expiredBankslipMessage:
		"Esse boleto não pode ser pago. Ele pode já ter sido pago, cancelado ou estar com erro na emissão.",
	missingRecipientTitle: "Dados do recebedor indisponíveis",
	missingRecipientMessage:
		"Não foi possível identificar os dados do beneficiário (nome e documento). Verifique o boleto e tente novamente.",
	insufficientBalance: "Saldo insuficiente",
	insufficientBalanceDescription:
		"Saldo disponível insuficiente para realizar o pagamento.",
	scheduledWarningTitle: "Pagamento será agendado para o próximo dia útil",
	scheduledWarningMessage:
		"Como esta solicitação está sendo feita após as 15h, o boleto será pago no próximo dia útil, já com o valor atualizado.",

	// Status modal - Success
	successTitle: "Tudo certo!",
	successDescription: "O boleto está sendo processado pelo time Financeiro.",
	conclude: "Concluir",
	close: "Fechar",

	// Status modal - Error
	errorTitle: "Não foi possível concluir a solicitação",
	errorDescription: "Ocorreu um problema ao tentar realizar a solicitação.",
	goBack: "Voltar",
	tryAgain: "Tentar novamente",

	// Actions
	continue: "Avançar",
	confirmRequest: "Confirmar solicitação",

	// Loading
	processingPayment: "Processando pagamento...",

	// Amount validation
	amountBelowMinimum: "O valor informado é menor que o valor mínimo permitido.",

	// Generic error
	genericError: "Ocorreu um erro. Tente novamente.",
};
